import React, { useState, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import useWindowDimensions from '../../utils/useWindowDimensions';

// API
import lancely from '../../utils/lancely';

import { Form, Button } from 'react-bootstrap';

import './Login.css';

function Reset() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const { width } = useWindowDimensions();

    const handleSubmit = (e) => {
        e.preventDefault();

        if (email.trim() === "") {
            toast.error("Email is required");
            return;
        }

        lancely.users.reset(email)
            .then(resp => {
                if (resp.status === true) {
                    toast.success(resp.message);
                    // Navigate to home
                    navigate('/');
                }
            })
            .catch(err => {
                console.log(err)
            })
    }


    return (
        <div>
            <div className={`container-fluid`}>
                <div className={`row g-0 d-flex justify-content-center align-items-center`} style={{ height: width > 768 ? '100vh' : '' }}>
                    <div className={`col-md-5 p-5 d-flex flex-column justify-content-center align-items-center text-center bg-primary text-light h-100`}>
                        <h1 className={`fw-bolder text-white fs-2qx pb-5 pb-md-10`}>Reset Your Password</h1>
                        <p className={`lead fw-bold`}>If you have an account with us, we will send you a reset email with instructions. Please allow some time for the email to be sent and check your junk folder!</p>
                        <img className={`img-fluid w-75 d-none d-md-block`} alt={`Solutions`} src={`/assets/icons/solutions.svg`} />

                    </div>
                    <div className={`col-md-7 mx-auto`}>
                        <div className={`d-flex flex-column justify-content-center align-items-center`} style={{ marginTop: width > 768 ? '' : '5vh' }}>
                            <h1 className={`text-dark mb-3`}>Reset</h1>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        className={`form-control form-control-lg form-control-solid`}
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Form.Group>

                                <div className={`text-center`}>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        className={`btn btn-lg btn-primary fw-bolder me-3 my-2`}
                                        onClick={handleSubmit}
                                    >
                                        Reset
                                    </Button>
                                    {/* <Button
                                        className={`btn btn-light-primary btn-lg fw-bolder my-2`}
                                        onClick={() => { toast.dark("Coming soon...") }}
                                    >
                                        <FcGoogle />
                                        Sign in with Google
                                    </Button> */}
                                </div>
                            </Form>
                            <div className="d-flex flex-row justify-content-center align-items-center w-100 mt-10 mb-10">
                                <div className="border-bottom border-gray-300 mw-50 w-25"></div>
                                <span className="fw-bold text-gray-400 fs-7 mx-2">OR</span>
                                <div className="border-bottom border-gray-300 mw-50 w-25"></div>
                            </div>
                            <p className={`text-gray-400 fw-bold fs-4`}>Remembered your password? <Link to="/">Login!</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reset